<template>
  <div>
    <div>
      <div class="comment-title">
        <b> {{ comment.userDisplayName }} </b>
        <span> - {{ formattedDate }} </span>
      </div>
      <div>
        <span class="comment-text">
          {{ comment.comment }}
        </span>
      </div>
    </div>

    <b-row class="text-center" v-if="comment.attachments != null && comment.attachments.length > 0">
      <!-- <pendency-comment-attachment :attachment="comment.attachments">
        </pendency-comment-attachment> -->
      <b-col md="3" v-for="(attachment, i) in comment.attachments" :key="i">
        <pendency-comment-attachment :attachment="attachment">
        </pendency-comment-attachment>
      </b-col>
    </b-row>
    <!-- <div>{{ comment }}</div> -->
  </div>
</template>

<script>
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
import PendencyCommentAttachment from "@/components_rms/checklist/pendency/PendencyCommentAttachment.vue";

export default {
  components: {
    FadeAlertDanger,
    SuccessFadeAlert,
    PendencyCommentAttachment,
  },
  props: {
    comment: Object,
  },
  data: function () {
    return {
      isTyping: false,
    };
  },
  created: function () { },
  computed: {
    formattedDate() {
      if (!this.comment) return "Carregando comentário";
      if (!this.comment.date) return "Sem data";
      let date = new Date(this.comment.date);
      return date.toLocaleString();
    },
  },
  methods: {
    //   typingCancel() {
    //       this.comment = "";
    //       this.isTyping = false;
    //   },
    //   typingStart() {
    //       this.isTyping = true;
    //   },
  },
};
</script>

